/**
 * Gestion du répéteur "Pour chaque PAC installée" pour les fiches PAC collectives
 * (BAR-TH-178/179/180, BAT-TH-162/163/164 — arrêté du 27 avril 2026).
 *
 * - Clic sur "+ Ajouter une PAC" → clone le data-prototype et ajoute un bloc Pac
 * - Clic sur "Supprimer" dans un bloc Pac → retire le bloc du DOM
 * - Mise en page col-12 vs col-6 pilotée par data-full-width-fields sur le container
 * - Pas de bouton Supprimer sur la PAC n°1
 *
 * Le rendu reproduit la structure Twig :
 *   <div class="col-lg-6 (ou col-lg-12)">
 *     <div class="field-container padding-left-7">
 *       <label>...</label>
 *       <div class="wrapper-input padding-right-10 no-margin">
 *         <input ... />
 *       </div>
 *     </div>
 *   </div>
 */
$(document).ready(function () {
    var $container = $('.pac-container');
    if ($container.length === 0) {
        return;
    }

    var fullWidthFields = [];
    try {
        fullWidthFields = JSON.parse($container.attr('data-full-width-fields') || '[]');
    } catch (e) {
        fullWidthFields = [];
    }

    /**
     * Met à jour le numéro affiché dans le titre + remplace 'n°x' (placeholder yml) ou
     * 'n°<digit>' dans tous les labels du bloc PAC par le numéro réel de la PAC.
     */
    function renumberPacs() {
        $container.children('.pac').each(function (idx) {
            var pacNum = idx + 1;
            var $pac = $(this);
            $pac.find('.pac-index').first().text(pacNum);
            var $removeBtn = $pac.find('.remove-pac');
            if (idx === 0) {
                $removeBtn.hide();
            } else {
                $removeBtn.show();
            }
            // Remplace n°<placeholder/ancien numéro> dans tous les <label> de la PAC
            $pac.find('label').each(function () {
                var $lbl = $(this);
                var txt = $lbl.text();
                if (/n°(x|\d+)/.test(txt)) {
                    $lbl.text(txt.replace(/n°(x|\d+)/g, 'n°' + pacNum));
                }
            });
        });
    }

    var counter = $container.children('.pac').length;

    function buildHeader(index, includeRemove) {
        var headerHtml = '<div class="row">' +
                '<div class="col-sm-12">' +
                    '<div class="ash_section_title" style="background:#f5f5f5;padding:8px 12px;">' +
                        'PAC n°<span class="pac-index">' + index + '</span>';
        if (includeRemove) {
            headerHtml +=
                        '<a href="#" class="remove-pac" style="float:right;color:#c00;">' +
                            '<i class="fa fa-times-circle" title="Supprimer cette PAC"></i> Supprimer' +
                        '</a>';
        }
        headerHtml +=
                    '</div>' +
                '</div>' +
            '</div>';
        return headerHtml;
    }

    /**
     * Extrait le nom du champ depuis l'attribut name d'un input/select.
     * Ex. ash_administration[pacs][0][invFoncfroid] → "invFoncfroid"
     */
    function getFieldName($protoField) {
        var $input = $protoField.find('input, select, textarea').first();
        var name = $input.attr('name') || '';
        var match = name.match(/\[([^\[\]]+)\]$/);
        return match ? match[1] : '';
    }

    /**
     * Reconstruit un bloc PAC avec la structure Twig (col-lg-6/col-lg-12 + field-container + wrapper-input).
     * Le prototype Symfony rend chaque champ comme un div top-level contenant label + widget.
     * On extrait label et widget, on reconstruit le markup attendu.
     */
    function layoutPacFields($protoContent) {
        var $protoFields = $protoContent.children();
        if ($protoFields.length === 0) {
            return $('<div></div>');
        }

        // Pré-indexation des proto-fields par nom pour le slot partagé invEtas/invCop
        var protoByName = {};
        $protoFields.each(function () {
            protoByName[getFieldName($($(this)))] = $(this);
        });

        // Helper : extrait label + widget d'un proto-field et reconstruit un .field-container
        function buildFieldContainer($protoField, extraClass) {
            var $label = $protoField.find('> label').first();
            var $widgetParts = $protoField.contents().filter(function () {
                return !(this.nodeType === 1 && $(this).is('label'));
            }).clone();

            var classes = 'field-container padding-left-7' + (extraClass ? ' ' + extraClass : '');
            var $fieldContainer = $('<div class="' + classes + '"></div>');
            if ($label.length) {
                $fieldContainer.append($label.clone());
            }
            var $wrapperInput = $('<div class="wrapper-input padding-right-10 no-margin"></div>');
            $wrapperInput.append($widgetParts);
            $fieldContainer.append($wrapperInput);
            return $fieldContainer;
        }

        var $output = $('<div></div>');
        var $currentRow = null;
        var col6Count = 0;

        $protoFields.each(function () {
            var $protoField = $(this);
            var fieldName = getFieldName($protoField);
            var isFullWidth = fullWidthFields.indexOf(fieldName) >= 0;

            // invCop est rendu dans le slot invEtas — on le saute ici
            if (fieldName === 'invCop') {
                return; // continue
            }

            if (fieldName === 'invEtas') {
                // Slot partagé invEtas + invCop dans un même col-lg-6
                if (col6Count === 0) {
                    $currentRow = $('<div class="row"></div>');
                    $output.append($currentRow);
                }
                var $slot = $('<div class="col-lg-6 etas-cop-slot"></div>');
                $slot.append(buildFieldContainer($protoField, 'etas-inner'));
                if (protoByName['invCop']) {
                    $slot.append(buildFieldContainer(protoByName['invCop'], 'cop-inner'));
                }
                $currentRow.append($slot);
                col6Count++;
                if (col6Count === 2) {
                    col6Count = 0;
                    $currentRow = null;
                }
                return; // continue
            }

            var $fieldContainer = buildFieldContainer($protoField);

            if (isFullWidth) {
                col6Count = 0;
                $currentRow = null;
                var $rowFull = $('<div class="row"></div>');
                $rowFull.append(
                    $('<div class="col-lg-12"></div>').append($fieldContainer)
                );
                $output.append($rowFull);
            } else {
                if (col6Count === 0) {
                    $currentRow = $('<div class="row"></div>');
                    $output.append($currentRow);
                }
                $currentRow.append(
                    $('<div class="col-lg-6"></div>').append($fieldContainer)
                );
                col6Count++;
                if (col6Count === 2) {
                    col6Count = 0;
                    $currentRow = null;
                }
            }
        });

        return $output;
    }

    /**
     * Affichage conditionnel des champs d'une PAC (par bloc .pac, donc indépendant par PAC).
     * Règles par fiche (cf. xlsx arrêté du 27 avril 2026) :
     *
     *   BAR-TH-178 / BAT-TH-162 :
     *     - invEtas      visible si invNomPacPower ≤ 400
     *     - invCop       visible si invNomPacPower > 400
     *     - invFoncfroid visible si invRafraichir = Oui
     *     - invEer       visible si invFoncfroid = "Rafraichissement actif"
     *     - invSeer      visible si invFoncfroid = "Rafraichissement passif ou geocooling"
     *
     *   BAR-TH-179 : aucune condition (tous les champs sont visibles)
     *
     *   BAR-TH-180 :
     *     - invTypePacAutre visible si invTypePacEau = "Autre"
     *
     *   BAT-TH-163 :
     *     - invEtas visible si invNomPacPower ≤ 400
     *     - invCop  visible si invNomPacPower > 400
     *
     *   BAT-TH-164 :
     *     - invEtas    visible si invNomPacPower ≤ 400
     *     - invCop     visible si invNomPacPower > 400
     *     - invTypePac visible si invNomPacPower ≤ 400
     */
    function applyConditionalDisplay($pacBlock) {
        var officialCode = typeof ELIGIBLE_WORK !== 'undefined' ? ELIGIBLE_WORK : null;

        // Helper : trouve le col-lg-* parent d'un champ (par son name suffix)
        function findFieldCol($pac, fieldName) {
            var $input = $pac.find('[name$="[' + fieldName + ']"]').first();
            if ($input.length === 0) return $();
            return $input.closest('[class*="col-lg-"]');
        }

        // Lit la valeur sélectionnée d'un champ (gère radio/select/input)
        function readFieldValue($pac, fieldName) {
            var $inputs = $pac.find('[name$="[' + fieldName + ']"]');
            if ($inputs.length === 0) return null;
            // Pour les radios : SEULEMENT la valeur cochée, sinon null
            if ($inputs.first().is(':radio')) {
                var $checked = $inputs.filter(':checked');
                return $checked.length ? $checked.val() : null;
            }
            return $inputs.val();
        }

        function update() {
            // BAR-TH-179 : aucune condition, on ne touche à rien
            if (officialCode === 'BAR-TH-179') {
                return;
            }

            var powerVal = parseFloat(readFieldValue($pacBlock, 'invNomPacPower'));
            var hasPower = !isNaN(powerVal) && powerVal > 0;

            // Etas vs COP selon la puissance — pour les 4 fiches concernées.
            // invEtas et invCop partagent un même col-lg-6 (.etas-cop-slot) — on toggle les
            // .field-container internes (.etas-inner / .cop-inner) au lieu du parent col-lg-*.
            if (['BAR-TH-178', 'BAT-TH-162', 'BAT-TH-163', 'BAT-TH-164'].indexOf(officialCode) >= 0) {
                $pacBlock.find('.etas-cop-slot .etas-inner').toggle(hasPower && powerVal <= 400);
                $pacBlock.find('.etas-cop-slot .cop-inner').toggle(hasPower && powerVal > 400);
            }

            // BAT-TH-164 : invTypePac aussi conditionné par la puissance
            if (officialCode === 'BAT-TH-164') {
                findFieldCol($pacBlock, 'invTypePac').toggle(hasPower && powerVal <= 400);
            }

            // BAR-TH-178 et BAT-TH-162 : FoncFroid (selon Rafraichir), EER/SEER (selon FoncFroid)
            if (officialCode === 'BAR-TH-178' || officialCode === 'BAT-TH-162') {
                var rafraichirVal = readFieldValue($pacBlock, 'invRafraichir');
                var rafraichirIsOui = rafraichirVal === '1' || rafraichirVal === 'true' || rafraichirVal === 1 || rafraichirVal === true;
                findFieldCol($pacBlock, 'invFoncfroid').toggle(rafraichirIsOui);

                var foncFroidVal = readFieldValue($pacBlock, 'invFoncfroid');
                findFieldCol($pacBlock, 'invEer').toggle(rafraichirIsOui && foncFroidVal === 'Rafraichissement actif');
                findFieldCol($pacBlock, 'invSeer').toggle(rafraichirIsOui && foncFroidVal === 'Rafraichissement passif ou geocooling');
            }

            // BAR-TH-180 : invTypePacAutre visible si invTypePacEau = "Autre"
            // (la valeur "autre" correspond au slug défini dans PacType pour le choix "Autre")
            if (officialCode === 'BAR-TH-180') {
                var typePacEauVal = readFieldValue($pacBlock, 'invTypePacEau');
                findFieldCol($pacBlock, 'invTypePacAutre').toggle(typePacEauVal === 'autre');
            }
        }

        // Listeners (sur le bloc .pac uniquement → isolation par PAC)
        // Pour la puissance : 'change' uniquement (pas 'input') → le toggle Etas/COP se déclenche
        // quand l'utilisateur quitte le champ (blur), pas à chaque caractère tapé.
        $pacBlock.on('change', '[name$="[invNomPacPower]"]', update);
        $pacBlock.on('change', '[name$="[invRafraichir]"]', update);
        $pacBlock.on('change', '[name$="[invFoncfroid]"]', update);
        $pacBlock.on('change', '[name$="[invTypePacEau]"]', update);

        // État initial
        update();
    }

    // Applique aux PAC déjà rendues côté serveur
    $container.children('.pac').each(function () {
        applyConditionalDisplay($(this));
    });

    // Ajout d'une nouvelle PAC
    $(document).on('click', '.add-pac', function (e) {
        e.preventDefault();

        var prototype = $container.attr('data-prototype');
        var newPacHtml = prototype.replace(/__name__/g, counter);

        var $protoWrapper = $('<div>' + newPacHtml + '</div>');
        // Le prototype Symfony peut être enveloppé dans un div racine — descend dedans s'il y en a un
        var $protoContent = $protoWrapper;
        if ($protoWrapper.children().length === 1 && $protoWrapper.children().first().is('div')) {
            $protoContent = $protoWrapper.children().first();
        }

        var $newPac = $('<div class="pac"></div>');
        $newPac.append(buildHeader(counter + 1, true));
        var $layouted = layoutPacFields($protoContent);
        $layouted.children().each(function () {
            $newPac.append(this);
        });

        $container.append($newPac);
        counter++;
        renumberPacs();

        // Active l'affichage conditionnel sur la nouvelle PAC
        applyConditionalDisplay($newPac);
    });

    // Suppression d'une PAC
    $(document).on('click', '.remove-pac', function (e) {
        e.preventDefault();
        if (!confirm('Êtes-vous sûr de vouloir supprimer cette PAC ?')) {
            return;
        }
        $(this).closest('.pac').remove();
        counter = $container.children('.pac').length;
        renumberPacs();
    });

    renumberPacs();
});
